module.exports = __webpack_public_path__ + "e4d89868a0ba21ab1eb68c30fb89e2ae.svg";